The name of the degree.
